import {
  sortColumnValues,
  filterValuesBySearch,
} from "../utils/columnFilterUtils";
import { useMemo } from "react";

export function useColumnCounts({
  column,
  searchQuery = "",
  isEnumColumn = false,
  getEnumDisplayValue,
  summaryValues,
}) {
  const counts = useMemo(() => {
    if (!summaryValues?.values) return {};
    const res = [...summaryValues.values];
    if (summaryValues.blank > 0) {
      res.unshift({ internalName: "<blank>", count: summaryValues.blank });
    }
    return res;
  }, [summaryValues?.values, summaryValues?.blank]);

  const totalUniqueValues = useMemo(() => {
    return summaryValues?.values?.length ?? 0;
  }, [summaryValues?.values]);

  const values = useMemo(() => {
    if (!summaryValues?.values) return [];
    const valueSet = new Set(summaryValues?.values.map((v) => v.internalName));
    const hasBlank = (summaryValues?.blank ?? 0) > 0;

    const sorted = sortColumnValues(valueSet, hasBlank, {
      isEnumColumn,
      column,
      getEnumDisplayValue,
    });
    return filterValuesBySearch(sorted, searchQuery, {
      isEnumColumn,
      column,
      getEnumDisplayValue,
    });
  }, [
    summaryValues?.values,
    summaryValues?.blank,
    isEnumColumn,
    column,
    getEnumDisplayValue,
    searchQuery,
  ]);
  return {
    values,
    counts,
    totalUniqueValues,
  };
}

export function useFilterStats({ column, columnType, summary }) {
  const dateBlankCount = useMemo(() => {
    if (!column || columnType !== "date" || !summary?.ranges) return 0;
    return summary.blank ?? 0;
  }, [column, columnType, summary]);

  const numberBounds = useMemo(() => {
    if (!column || columnType !== "number") return null;
    if (!summary) return null;
    return { min: summary.min, max: summary.max };
  }, [column, columnType, summary]);

  const histogramBins = useMemo(() => {
    if (!column || columnType !== "number" || !numberBounds) return [];
    if (!summary?.histogram) return [];
    return summary.histogram;
  }, [column, columnType, numberBounds, summary]);
  return {
    dateBlankCount,
    numberBounds,
    histogramBins,
  };
}
